// extracted by mini-css-extract-plugin
export default {"postOverlay":"postOverlay_postOverlay__F3iZV"};